<template>
  <div class="home">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="1"></menuBox>
      <div class="banner-text">
        <div class="title">
          Superior Always Limited 公司簡介
        </div>
        <!-- <div class="subtitle">副標題副標題副標題副標題副標題</div> -->
        <div class="text">
          Superior Always Limited專注於流量廣告，助力您的品牌在數字世界中脫穎而出。我們提供全面的廣告代理服務，透過精準的流量採購和創意廣告投放，將您的品牌信息傳遞給目標受眾。以技術創新和專業團隊為支持，我們致力於為客戶打造卓越的數字營銷策略，助您在激烈的市場競爭中取得成功。選擇卓越，引領品牌超越期待
        </div>
      </div>
    </div>
    <div class="user-serve-box">
      <div class="title">
        突破極限，引領創新
      </div>
      <!-- <div class="subtitle">副標題副標題副標題副標題副標題</div> -->
      <div class="server-list-box">
        <div class="tit">
          我們的核心競爭力包括：
        </div>
        <div class="item">
          <img src="../assets/check.png" alt="" />
          - 深度洞察市場，準確分析趨勢，洞悉用戶需求
        </div>
        <div class="item">
          <img src="../assets/check.png" alt="" />
          - 引領創新營銷策略，將最新的數字化趨勢融入廣告服務，開創更多可能性。
        </div>
        <div class="item">
          <img src="../assets/check.png" alt="" />
          - 以全球化視野整合優質資源，建立廣泛的合作網絡。
        </div>
        <div class="item">
          <img src="../assets/check.png" alt="" />
          - 以客戶為中心，提供個性化的定制服務。了解客戶獨特需求，量身打造廣告解決方案，實現最佳的品牌推廣效果
        </div>
      </div>
    </div>

    <div class="business-box">
      <div class="business-text">
        <div class="business-title">公司簡介</div>
        <div class="b-text">
          Superior Always Limited是一家專業從事流量廣告的公司，致力於為客戶提供高效、有創意且全方位的廣告解決方案。我們擁有一支由行業專業人才組成的團隊，致力於通過卓越的技術實力和深度市場洞察，為客戶實現品牌在數字化時代的卓越表現。
          <br />
          <br />
          我們以創新的營銷策略、全球資源整合和客戶定制服務著稱。透過前瞻性的思維和全球化的視野，我們助力客戶實現在多平臺多地區的廣告目標。卓越永遠有限公司擁抱流量廣告領域的挑戰，並以專業、創新和客戶滿意度為核心價值，為客戶的品牌增添動力。
        </div>
      </div>
      <div class="business-text business-text-1">
        <div class="business-title">企業願景</div>
        <div class="b-text">
          Superior Always Limited的愿景是成為流量廣告領域的佼佼者，為客戶提供全球領先的廣告解決方案。我們志在通過創新科技、卓越服務和全球視野，引領行業發展，為客戶實現品牌全球化的夢想。卓越永遠有限公司將不斷追求卓越，致力於成為客戶信賴的首選合作夥伴，攜手共創更加美好的數字營銷未來。
        </div>
      </div>
      <div class="business-text business-text-2">
        <div class="business-title">企業文化</div>
        <div class="b-text">
          Superior Always Limited秉持著卓越與創新的企業文化，強調以客戶為中心，團結合作，追求卓越品質和不斷創新。我們擁抱多元文化，尊重每一位團隊成員的貢獻，並注重員工的專業成長和個人價值的實現。在卓越永遠有限公司，我們追求卓越，激發創意，堅守誠信，營造一個積極向上、充滿活力的工作環境。
        </div>
      </div>
    </div>

    <div class="partner-box">
      <div class="p-title">核心團隊</div>
      <div class="p-subtitle">
        我們建立了一支高水準的專業業務團隊，並將其細分為三個領域，可以為您的品牌海外擴展提供全面支持。
      </div>
      <div class="partner-list">
        <div class="item">
          <img src="../assets/team-1.png" alt="" />
          <div class="tit">技術團隊</div>
          <div class="msg">
            我們的技術團隊由一群富有創造力和經驗豐富的工程師組成，致力於開發前沿技術，確保我們的廣告投放系統始終領先於行業。他們對技術的敏銳洞察力和卓越的執行力是我們成功的基石。
          </div>
        </div>
        <div class="item">
          <img src="../assets/team-2.png" alt="" />
          <div class="tit">市場團隊</div>
          <div class="msg">
            我們的市場團隊精通全球市場，深諳廣告行業的動向。他們通過深入的市場研究和數據分析，為客戶制定精準的廣告策略，確保品牌在競爭激烈的數字領域中脫穎而出。
          </div>
        </div>
        <div class="item">
          <img src="../assets/team-2.png" alt="" />
          <div class="tit">客戶服務團隊</div>
          <div class="msg">
            客戶服務團隊是我們成功的橋樑，他們注重客戶需求，傾聽反饋，為客戶提供個性化的服務。他們始終秉持務實的工作態度，確保客戶在合作過程中享受到最佳的體驗。
          </div>
        </div>
      </div>
    </div>
    <div class="development-box">
      <div class="title">
        發展願景
      </div>
      <div class="content">
        我们的發展愿景源於對未來數字營銷領域的深刻洞察和對客戶成功的不懈追求。我們立志成為全球最優秀的流量廣告公司之一，不僅在技術創新和服務卓越上屢創佳績，更在協助客戶實現其業務目標方面贏得口碑。
        <br />
        <br />
        我們追求卓越，努力打造一支充滿創造力、擁有豐富經驗的專業團隊。未來，我們將繼續投入更多資源於技術創新和團隊培訓，不斷拓展全球合作伙伴關係，以實現共同成長和繁榮。我們堅信，通過堅持不懈的努力，Superior Always Limited將成為引領行業發展的數字營銷領航者。
      </div>
    </div>
    <div class="enterprise-box">
      <div class="title">
        企業優勢
      </div>
      <div class="l-title">
        Superior Always Limited以卓越服務、領先技術和不斷創新為核心，助力客戶在競爭激烈的市場中取得可觀的成果。
      </div>
      <div class="enterprise-list">
        <div class="item">
          <img src="../assets/enterprise-1.png" alt="" />
          <div class="tit">流量引領</div>
          <div class="msg">
            Superior Always Limited透過精密的數據分析和廣告定位，我們為客戶提供具有針對性的廣告投放策略，確保品牌信息準確傳達到目標受眾手中，最大化提高品牌曝光度。
          </div>
        </div>
        <div class="item">
          <img src="../assets/enterprise-2.png" alt="" />
          <div class="tit">創新科技</div>
          <div class="msg">
            Superior Always Limited秉持先進科技的理念，不斷融合最新的廣告技術，確保客戶始終站在數字營銷的前沿，與快速發展的市場保持同步。
          </div>
        </div>
        <div class="item">
          <img src="../assets/enterprise-3.png" alt="" />
          <div class="tit">客戶關係</div>
          <div class="msg">
            建立緊密的合作關系是我們成功的關鍵。我們與客戶緊密合作，了解他們的需求，提供定制化的解決方案，以實現共同的成功。
          </div>
        </div>
        <div class="item">
          <img src="../assets/enterprise-4.png" alt="" />
          <div class="tit">創意創新</div>
          <div class="msg">
            Superior Always Limited擁有一支充滿創意的團隊，注重廣告的創新性。無論是品牌建設還是推廣活動，我們都以獨特而引人注目的方式展現客戶的價值與個性。
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.banner-box {
  background-image: url(../assets/swiper-1.png);
  width: 100%;
  height: 750px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    // margin-top: 165px;
    margin-left: 360px;
    padding-top: 165px;
    width: 660px;

    .title {
      font-size: 40px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #333333;
    }

    .subtitle {
      font-size: 26px;
      font-weight: 500;
      color: #333333;
    }

    .text {
      font-size: 20px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #999999;
      margin-top: 30px;
    }
  }
}

.user-serve-box {
  margin-top: 100px;
  background-image: url(../assets/swiper-3.png);
  width: 100%;
  height: 627px;
  overflow: hidden;
  background-size: 100% 100%;
  .title {
    font-size: 32px;
    width: 660px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-left: 900px;
    margin-top: 40px;
  }

  .subtitle {
    font-size: 26px;
    margin-top: 24px;
    text-align: center;
    font-weight: 500;
    color: #999999;
  }

  .server-list-box {
    margin-left: 900px;
    text-align: left;
    margin-top: 34px;
    .tit {
      font-size: 24px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #333333;
    }
    .item {
      font-size: 20px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #999999;
      margin-top: 20px;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.business-box {
  background-image: url(../assets/swiper-2.png);
  width: 100%;
  height: 1000px;
  margin-top: 100px;
  background-size: 100% 100%;
  position: relative;

  .business-text {
    width: 900px;
    margin-left: 460px;
    text-align: center;
    overflow: hidden;
    .business-title {
      font-size: 40px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #333333;
      margin-top: 40px;
      margin-bottom: 24px;
    }

    .b-text {
      font-size: 20px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #999999;
    }
  }
  .business-text-1 {
    margin-left: 260px;
    max-width: 600px;
    float: left;
    margin-top: 250px;
    text-align: left;
    .business-title {
      color: #fff;
    }
    .b-text {
      color: #fff;
    }
  }
  .business-text-2 {
    margin-right: 260px;
    margin-top: 250px;
    margin-left: 0;
    max-width: 600px;
    text-align: left;
    float: right;
    .business-title {
      color: #fff;
    }
    .b-text {
      color: #fff;
    }
  }
}

.partner-box {
  padding: 100px 360px;
  text-align: center;

  .p-title {
    font-size: 40px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
  }

  .p-subtitle {
    font-size: 20px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #999999;
    margin-top: 24px;
  }

  .partner-list {
    display: flex;
    justify-content: space-between;
    margin-top: 70px;
    .item {
      width: 360px;
      img {
        width: 360px;
        height: 240px;
      }
      .tit {
        font-size: 24px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #333333;
        margin: 24px 0;
      }
      .msg {
        font-size: 20px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}
.development-box {
  background-image: url(../assets/swiper-4.png);
  width: 100%;
  height: 627px;
  background-size: 100% 100%;
  overflow: hidden;
  .title {
    margin-left: 900px;
    margin-top: 100px;
    font-size: 32px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
  }
  .content {
    font-size: 20px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #999999;
    margin-top: 40px;
    max-width: 700px;
    margin-left: 900px;
  }
}
.enterprise-box {
  margin-top: 100px;
  background-image: url(../assets/swiper-5.png);
  width: 100%;
  height: 785px;
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
  .title {
    font-size: 40px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
    margin-top: 80px;
  }
  .l-title {
    font-size: 20px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #999999;
    margin-top: 24px;
    margin-bottom: 48px;
    padding: 0 460px;
  }
  .enterprise-list {
    padding: 0 170px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item {
      width: 380px;
      height: 394px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
      img {
        width: 80px;
        height: 80px;
        margin-top: 40px;
      }
      .tit {
        font-size: 24px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #53ba27;
        margin-top: 10px;
      }
      .msg {
        font-size: 18px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #999999;
        margin-top: 10px;
        padding: 0 30px;
      }
    }
  }
}
</style>
